import React, { FC, useMemo } from 'react';
import { AccordionCont } from './Accordion.styles';
import AccordionTile from './AccordionTile/AccordionTile';

interface IAccordion {
  setItemStatus: (id: string) => void;
  assignedItemsArr: any[];
  notAssignedItemsArr: any[];
  changeItemAssigment: (id: string) => void;
  setIsTransitionBlocked: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
}

const Accordion: FC<IAccordion> = ({
  setItemStatus,
  assignedItemsArr,
  notAssignedItemsArr,
  changeItemAssigment,
  setIsTransitionBlocked,
  title,
}) => {
  const renderAssignedItems = useMemo(() => {
    return assignedItemsArr.map((item: any) => (
      <AccordionTile
        scrollId={`${title}${item.name}`}
        key={item.id}
        item={item}
        active={item.active}
        setActive={setItemStatus}
        notAssigned={!item.assigned}
        changeItemAssigment={changeItemAssigment}
        setIsTransitionBlocked={setIsTransitionBlocked}
      />
    ));
  }, [assignedItemsArr]);

  const renderNotAssignedItems = useMemo(() => {
    return notAssignedItemsArr.map((item: any) => (
      <AccordionTile
        scrollId={`${title}${item.name}`}
        key={item.id}
        item={item}
        active={item.active}
        setActive={setItemStatus}
        notAssigned={!item.assigned}
        changeItemAssigment={changeItemAssigment}
        setIsTransitionBlocked={setIsTransitionBlocked}
      />
    ));
  }, [changeItemAssigment, notAssignedItemsArr, title]);

  return (
    <AccordionCont id="AccordionCont" data-testid="AccordionCont">
      {renderAssignedItems}
      {renderNotAssignedItems}
    </AccordionCont>
  );
};

export default Accordion;
